import { mapState } from 'vuex';
export default {
  data() {
    return {
      menu: []
    };
  },
  computed: mapState(['user']),
  created() {
    if (
      this.user.accountAccountGroupId === '1' ||
      this.user.accountAccountGroupId === '2'
    ) {
      this.menu = [
        {
          title: 'Monitoring',
          icon: require('@/assets/icons/monitoring-dark.svg'),
          url: 'Map'
        },
        {
          title: 'Laporan',
          icon: require('@/assets/icons/laporan-dark.svg'),
          url: 'report'
        },
        {
          title: 'Dashboard',
          icon: require('@/assets/icons/dashboard-dark.svg'),
          url: 'dashboard'
        },
        {
          title: 'Pemberitahuan',
          icon: require('@/assets/icons/pengumuman-dark.svg'),
          url: 'announcement'
        },
        {
          title: 'Anggota',
          icon: require('@/assets/icons/anggota-dark.svg'),
          url: 'user'
        },
        {
          title: 'Wilayah',
          icon: require('@/assets/icons/unit-dark.svg'),
          url: 'unit'
        },
        {
          title: 'Event',
          icon: require('@/assets/icons/calendar.png'),
          url: 'event'
        }
        // {
        //   title: 'Beranda',
        //   icon: require('@/assets/icons/home-dark.svg'),
        //   url: 'menu'
        // }
      ];
    } else {
      this.menu = [
        {
          title: 'Anggota',
          icon: require('@/assets/icons/anggota-dark.svg'),
          url: 'user'
        }
      ];
    }
  }
};
